package com.rosario.juridico.ui.screens

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.rosario.juridico.domain.model.PasoProcedimientoPromesa
import com.rosario.juridico.domain.model.PromesaParser
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.launch

class AgendaPromesaViewModel : ViewModel() {
    private val _pasos = MutableStateFlow<List<PasoProcedimientoPromesa>>(emptyList())
    val pasos: StateFlow<List<PasoProcedimientoPromesa>> = _pasos.asStateFlow()

    private val _currentActiveStepIndex = MutableStateFlow(0)
    val currentActiveStepIndex: StateFlow<Int> = _currentActiveStepIndex.asStateFlow()

    private val _loading = MutableStateFlow(true)
    val loading: StateFlow<Boolean> = _loading.asStateFlow()

    init {
        cargarPasos()
    }

    fun cargarPasos() {
        viewModelScope.launch {
            _loading.value = true
            _pasos.value = PromesaParser.cargarPasos()
            _loading.value = false
        }
    }

    fun markStepAsCompleted() {
        if (_currentActiveStepIndex.value < _pasos.value.size - 1) {
            _currentActiveStepIndex.value += 1
        }
    }

    fun resetProgress() {
        _currentActiveStepIndex.value = 0
    }
}
